export class CooldownTimer {
  readonly duration: number;
  private lastToggleAt: number;

  constructor(duration: number) {
    this.duration = duration;
    this.lastToggleAt = -duration; // Start ready
  }

  get isReady(): boolean {
    return Date.now() - this.lastToggleAt >= this.duration;
  }

  get remainingMs(): number {
    const elapsed = Date.now() - this.lastToggleAt;
    return Math.max(0, this.duration - elapsed);
  }

  get progress(): number {
    const elapsed = Date.now() - this.lastToggleAt;
    return Math.min(1, elapsed / this.duration);
  }

  trigger(): void {
    this.lastToggleAt = Date.now();
  }

  reset(): void {
    this.lastToggleAt = -this.duration;
  }
}
